import React from 'react';
import './prescriptionFooter.scss';
export const PrescriptionFooter = () => {
  return (
    <div className='mainPrescriptionFooter'>
      <section>
        <h4>Other Instructions</h4>
        <p>Please note that all medicines need to continue as specified</p>
        <article>
          <p>
            Patients may choose other generics as per their choice. Patients are requested to read the label carefully before substituting other brands on their own responsibility. ASCAS is not liable
            for quality of product dispensed by the pharmacy or chemist
          </p>
        </article>
      </section>
    </div>
  );
};
